export const REPORT_IMAGE_ROLE_ATTRIBUTE = "data-report-image-role";

export const REPORT_IMAGE_ROLE = {
  clinicalPhoto: "clinical-photo",
  clinicalAttachment: "clinical-attachment",
  organMap: "organ-map",
  optionalBranding: "optional-branding",
} as const;

export type ReportImageRole =
  (typeof REPORT_IMAGE_ROLE)[keyof typeof REPORT_IMAGE_ROLE];
